import { useSnapshot } from '../lib/snapshot-context';
import { ContactForm } from '../components/ContactForm/ContactForm';
import styles from './ContactPage.module.css';

export function ContactPage() {
  const { settings } = useSnapshot();
  return (
    <main className={styles.page}>
      <title>{`Contact — ${settings.heroTitle}`}</title>
      <div className={styles.intro}>
        <h1 className={styles.heading}>Contact</h1>
        <p className={styles.lead}>
          For commissions, exhibitions, collaborations or enquiries about available work, send a
          message and I will get back to you.
        </p>
        {settings.contactEmail && (
          <p className={styles.direct}>
            <span className="label">Email</span>
            <a href={`mailto:${settings.contactEmail}`}>{settings.contactEmail}</a>
          </p>
        )}
        {settings.social.length > 0 && (
          <p className={styles.direct}>
            <span className="label">Elsewhere</span>
            {settings.social.map((s) => (
              <a key={s.url} href={s.url} target="_blank" rel="noreferrer">
                {s.label}
              </a>
            ))}
          </p>
        )}
      </div>
      <ContactForm />
    </main>
  );
}
